import { t } from "@/themes/theme.ts";
import { styled } from "@linaria/react";

export const BasicInput = styled.input`
  border: ${t.brandBorderSegment};
  border-radius: ${t.brandBorderRadius};
  padding: 10px;
`;

export const BasicInputSmall = styled(BasicInput)`
  padding: 4px 6px;
`;

export const DefaultInputMax = 100;
export const DefaultInputMin = 0;
export const DefaultInputStep = 1;
